import WarTime from './views/war-time';
export default WarTime;
